import Client from '../client';

const AuthService =  
{
    autorizar() {return Client.post('auth', {});}
};

export default AuthService;